import { create } from "../../../../../common/utils/zustand_state_manager";

type State = {
  IdItemProcesso: number;
  IdItemProcessoInteresse: number;
};


type Action = {
  setFilters: (filters: Partial<State>) => void;
  clearFilters: () => void;

};


export const initialFiltersValues: State = {
  IdItemProcesso: 0,
  IdItemProcessoInteresse: 0,
};

export const useItemProcessosInteresseFilters = create<State & Action>((set) => ({
  ...initialFiltersValues,
  setFilters: (filters) => set((state) => ({ ...state, ...filters })),
  clearFilters: () => set((state) => ({
    ...initialFiltersValues,
  })),
}));